(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-standalone"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Only act when the Shopify form was posted successfully
  var hasParam = window.location.search.indexOf('customer_posted=true') > -1;
  if (!hasParam) return;

  // Only act if the anchor exists on this page
  var targetId = 'newsletter-signup';
  var el = document.getElementById(targetId);
  if (!el) return;

  // Jump to the signup so the user sees the success message
  if (location.hash !== '#' + targetId) {
    location.hash = '#' + targetId;
  } else {
    // If the hash is already there, ensure we scroll into view
    setTimeout(function(){ el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 0);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xxl-article-newsletter"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Only act when the Shopify form was posted successfully
  var hasParam = window.location.search.indexOf('customer_posted=true') > -1;
  if (!hasParam) return;

  // Only act if the anchor exists on this page
  var targetId = 'newsletter-signup';
  var el = document.getElementById(targetId);
  if (!el) return;

  // Jump to the signup so the user sees the success message
  if (location.hash !== '#' + targetId) {
    location.hash = '#' + targetId;
  } else {
    // If the hash is already there, ensure we scroll into view
    setTimeout(function(){ el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 0);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
